import { css } from "@emotion/react";

import { Avatar } from "components/shared/library/Avatar";

import {
  SHIMMER_KEYFRAME,
  SHIMMER_TRANSITION_DURATION,
  SHIMMER_TRANSITION_TIMING_FUNCTION,
} from "constants/animations";
import { uiGray, white } from "constants/colors";

const style = {
  wrapper: css({
    display: "flex",
    justifyContent: "space-between",
    width: "-webkit-fill-available",
    animation: `${SHIMMER_KEYFRAME} ${SHIMMER_TRANSITION_DURATION} infinite ${SHIMMER_TRANSITION_TIMING_FUNCTION}`,
    background: `linear-gradient(to right, ${white} 4%, ${uiGray.pageBackground} 25%, ${white} 66%)`,
    backgroundSize: "1000px 100%",
  }),
  innerContainer: css({
    display: "flex",
    gap: 8,
    alignItems: "center",
  }),
  orgInfo: css({
    display: "flex",
    flexDirection: "column",
    gap: 4,
  }),
};

export const JobLoadingSkeleton = () => {
  return (
    <div css={style.wrapper}>
      <div css={style.innerContainer}>
        <Avatar frameShape={"roundedSquare"} isOrg />
        <div css={style.orgInfo}></div>
      </div>
      <div css={style.innerContainer}></div>
    </div>
  );
};
